import React from "react";
import { useController } from "react-hook-form";
import PropTypes from "prop-types";
import { Form } from "@weezevent/nacre";

/**
 * A controlled password input component integrated with react-hook-form.
 * Must be wrapped by a FormContext.
 */
const FormFieldPasswordIcon = ({
	name,
	control,
	required,
	onChange: onExternalChange,
	...props
}) => {
	const {
		field: { onChange, value },
		fieldState: { error }
	} = useController({
		name,
		control,
		rules: { required }
	});

	const handleChange = e => {
		const newValue = e.target.value;
		onChange(e);
		if (onExternalChange) {
			onExternalChange(newValue);
		}
	};

	return (
		<Form.PasswordIcon
			{...props}
			name={name}
			value={value || ""}
			onChange={handleChange}
			error={!!error}
		/>
	);
};

FormFieldPasswordIcon.propTypes = {
	name: PropTypes.string.isRequired,
	control: PropTypes.object.isRequired,
	required: PropTypes.bool,
	onChange: PropTypes.func
};

FormFieldPasswordIcon.defaultProps = {
	required: false,
	onChange: () => {}
};

export default FormFieldPasswordIcon;
